/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  VesselResult,
} from '../models';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    VesselResultFromJSON,
    VesselResultToJSON,
} from '../models';

export interface QueryQueryGetRequest {
    buildYearGreaterThan?: any;
    buildYearLessThan?: any;
    buildYearMatch?: any;
    registeredOwnerMatch?: any;
    registeredOwnerContains?: any;
    vesselNameMatch?: any;
    vesselNameContains?: any;
    vesselTypeMatch?: QueryQueryGetVesselTypeMatchEnum;
    deadweightTonnageGreaterThan?: any;
    deadweightTonnageLessThan?: any;
    netTonnageGreaterThan?: any;
    netTonnageLessThan?: any;
    grossTonnageGreaterThan?: any;
    grossTonnageLessThan?: any;
    vesselLengthMetersGreaterThan?: any;
    vesselLengthMetersLessThan?: any;
    vesselWidthMetersGreaterThan?: any;
    vesselWidthMetersLessThan?: any;
    registerPortMatch?: any;
    registerPortContains?: any;
    flagDateGreaterThan?: any;
    flagDateLessThan?: any;
    vesselStatusMatch?: QueryQueryGetVesselStatusMatchEnum;
    formerVesselNameMatch?: any;
    formerVesselNameContains?: any;
    currentSogGreaterThan?: any;
    currentSogLessThan?: any;
    latestPortCallMatch?: any;
    positionWithin?: any;
    engineTypeMatch?: QueryQueryGetEngineTypeMatchEnum;
    deficiencyCountGreaterThan?: any;
    deficiencyCountLessThan?: any;
    deficiencyCountMatch?: any;
    isDetained?: any;
    isBanned?: any;
    isSanctioned?: any;
    sanctionedByMatch?: any;
    sanctionTypeMatch?: QueryQueryGetSanctionTypeMatchEnum;
    inspectionPortMatch?: any;
    inspectionPortContains?: any;
}

export interface ReadByImoImoVesselImoNumberGetRequest {
    vesselImoNumber: any;
}

export interface ReadByMmsiMmsiVesselMmsiNumberGetRequest {
    vesselMmsiNumber: any;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Retrieve the list of available fields for filtering ship data specifically implemented for MDM
     * Get available filter fields that are specifically implemented in MDM
     */
    async filterTokensGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/filter_tokens`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Retrieve the list of available fields for filtering ship data specifically implemented for MDM
     * Get available filter fields that are specifically implemented in MDM
     */
    async filterTokensGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.filterTokensGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * query endpoint documentation
     * Query
     */
    async queryQueryGetRaw(requestParameters: QueryQueryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        if (requestParameters.buildYearGreaterThan !== undefined) {
            queryParameters['build_year_greater_than'] = requestParameters.buildYearGreaterThan;
        }

        if (requestParameters.buildYearLessThan !== undefined) {
            queryParameters['build_year_less_than'] = requestParameters.buildYearLessThan;
        }

        if (requestParameters.buildYearMatch !== undefined) {
            queryParameters['build_year_match'] = requestParameters.buildYearMatch;
        }

        if (requestParameters.registeredOwnerMatch !== undefined) {
            queryParameters['registered_owner_match'] = requestParameters.registeredOwnerMatch;
        }

        if (requestParameters.registeredOwnerContains !== undefined) {
            queryParameters['registered_owner_contains'] = requestParameters.registeredOwnerContains;
        }

        if (requestParameters.vesselNameMatch !== undefined) {
            queryParameters['vessel_name_match'] = requestParameters.vesselNameMatch;
        }

        if (requestParameters.vesselNameContains !== undefined) {
            queryParameters['vessel_name_contains'] = requestParameters.vesselNameContains;
        }

        if (requestParameters.vesselTypeMatch !== undefined) {
            queryParameters['vessel_type_match'] = requestParameters.vesselTypeMatch;
        }

        if (requestParameters.deadweightTonnageGreaterThan !== undefined) {
            queryParameters['deadweight_tonnage_greater_than'] = requestParameters.deadweightTonnageGreaterThan;
        }

        if (requestParameters.deadweightTonnageLessThan !== undefined) {
            queryParameters['deadweight_tonnage_less_than'] = requestParameters.deadweightTonnageLessThan;
        }

        if (requestParameters.netTonnageGreaterThan !== undefined) {
            queryParameters['net_tonnage_greater_than'] = requestParameters.netTonnageGreaterThan;
        }

        if (requestParameters.netTonnageLessThan !== undefined) {
            queryParameters['net_tonnage_less_than'] = requestParameters.netTonnageLessThan;
        }

        if (requestParameters.grossTonnageGreaterThan !== undefined) {
            queryParameters['gross_tonnage_greater_than'] = requestParameters.grossTonnageGreaterThan;
        }

        if (requestParameters.grossTonnageLessThan !== undefined) {
            queryParameters['gross_tonnage_less_than'] = requestParameters.grossTonnageLessThan;
        }

        if (requestParameters.vesselLengthMetersGreaterThan !== undefined) {
            queryParameters['vessel_length_meters_greater_than'] = requestParameters.vesselLengthMetersGreaterThan;
        }

        if (requestParameters.vesselLengthMetersLessThan !== undefined) {
            queryParameters['vessel_length_meters_less_than'] = requestParameters.vesselLengthMetersLessThan;
        }

        if (requestParameters.vesselWidthMetersGreaterThan !== undefined) {
            queryParameters['vessel_width_meters_greater_than'] = requestParameters.vesselWidthMetersGreaterThan;
        }

        if (requestParameters.vesselWidthMetersLessThan !== undefined) {
            queryParameters['vessel_width_meters_less_than'] = requestParameters.vesselWidthMetersLessThan;
        }

        if (requestParameters.registerPortMatch !== undefined) {
            queryParameters['register_port_match'] = requestParameters.registerPortMatch;
        }

        if (requestParameters.registerPortContains !== undefined) {
            queryParameters['register_port_contains'] = requestParameters.registerPortContains;
        }

        if (requestParameters.flagDateGreaterThan !== undefined) {
            queryParameters['flag_date_greater_than'] = requestParameters.flagDateGreaterThan;
        }

        if (requestParameters.flagDateLessThan !== undefined) {
            queryParameters['flag_date_less_than'] = requestParameters.flagDateLessThan;
        }

        if (requestParameters.vesselStatusMatch !== undefined) {
            queryParameters['vessel_status_match'] = requestParameters.vesselStatusMatch;
        }

        if (requestParameters.formerVesselNameMatch !== undefined) {
            queryParameters['former_vessel_name_match'] = requestParameters.formerVesselNameMatch;
        }

        if (requestParameters.formerVesselNameContains !== undefined) {
            queryParameters['former_vessel_name_contains'] = requestParameters.formerVesselNameContains;
        }

        if (requestParameters.currentSogGreaterThan !== undefined) {
            queryParameters['current_sog_greater_than'] = requestParameters.currentSogGreaterThan;
        }

        if (requestParameters.currentSogLessThan !== undefined) {
            queryParameters['current_sog_less_than'] = requestParameters.currentSogLessThan;
        }

        if (requestParameters.latestPortCallMatch !== undefined) {
            queryParameters['latest_port_call_match'] = requestParameters.latestPortCallMatch;
        }

        if (requestParameters.positionWithin !== undefined) {
            queryParameters['position_within'] = requestParameters.positionWithin;
        }

        if (requestParameters.engineTypeMatch !== undefined) {
            queryParameters['engine_type_match'] = requestParameters.engineTypeMatch;
        }

        if (requestParameters.deficiencyCountGreaterThan !== undefined) {
            queryParameters['deficiency_count_greater_than'] = requestParameters.deficiencyCountGreaterThan;
        }

        if (requestParameters.deficiencyCountLessThan !== undefined) {
            queryParameters['deficiency_count_less_than'] = requestParameters.deficiencyCountLessThan;
        }

        if (requestParameters.deficiencyCountMatch !== undefined) {
            queryParameters['deficiency_count_match'] = requestParameters.deficiencyCountMatch;
        }

        if (requestParameters.isDetained !== undefined) {
            queryParameters['is_detained'] = requestParameters.isDetained;
        }

        if (requestParameters.isBanned !== undefined) {
            queryParameters['is_banned'] = requestParameters.isBanned;
        }

        if (requestParameters.isSanctioned !== undefined) {
            queryParameters['is_sanctioned'] = requestParameters.isSanctioned;
        }

        if (requestParameters.sanctionedByMatch !== undefined) {
            queryParameters['sanctioned_by_match'] = requestParameters.sanctionedByMatch;
        }

        if (requestParameters.sanctionTypeMatch !== undefined) {
            queryParameters['sanction_type_match'] = requestParameters.sanctionTypeMatch;
        }

        if (requestParameters.inspectionPortMatch !== undefined) {
            queryParameters['inspection_port_match'] = requestParameters.inspectionPortMatch;
        }

        if (requestParameters.inspectionPortContains !== undefined) {
            queryParameters['inspection_port_contains'] = requestParameters.inspectionPortContains;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/query`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * query endpoint documentation
     * Query
     */
    async queryQueryGet(requestParameters: QueryQueryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.queryQueryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read By Imo
     */
    async readByImoImoVesselImoNumberGetRaw(requestParameters: ReadByImoImoVesselImoNumberGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VesselResult>> {
        if (requestParameters.vesselImoNumber === null || requestParameters.vesselImoNumber === undefined) {
            throw new runtime.RequiredError('vesselImoNumber','Required parameter requestParameters.vesselImoNumber was null or undefined when calling readByImoImoVesselImoNumberGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/imo/{vessel_imo_number}`.replace(`{${"vessel_imo_number"}}`, encodeURIComponent(String(requestParameters.vesselImoNumber))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VesselResultFromJSON(jsonValue));
    }

    /**
     * Read By Imo
     */
    async readByImoImoVesselImoNumberGet(requestParameters: ReadByImoImoVesselImoNumberGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VesselResult> {
        const response = await this.readByImoImoVesselImoNumberGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Read By Mmsi
     */
    async readByMmsiMmsiVesselMmsiNumberGetRaw(requestParameters: ReadByMmsiMmsiVesselMmsiNumberGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VesselResult>> {
        if (requestParameters.vesselMmsiNumber === null || requestParameters.vesselMmsiNumber === undefined) {
            throw new runtime.RequiredError('vesselMmsiNumber','Required parameter requestParameters.vesselMmsiNumber was null or undefined when calling readByMmsiMmsiVesselMmsiNumberGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/mmsi/{vessel_mmsi_number}`.replace(`{${"vessel_mmsi_number"}}`, encodeURIComponent(String(requestParameters.vesselMmsiNumber))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VesselResultFromJSON(jsonValue));
    }

    /**
     * Read By Mmsi
     */
    async readByMmsiMmsiVesselMmsiNumberGet(requestParameters: ReadByMmsiMmsiVesselMmsiNumberGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VesselResult> {
        const response = await this.readByMmsiMmsiVesselMmsiNumberGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve the list of available fields for filtering ship data
     * Get available filter fields
     */
    async tokenGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Retrieve the list of available fields for filtering ship data
     * Get available filter fields
     */
    async tokenGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.tokenGetRaw(initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const QueryQueryGetVesselTypeMatchEnum = {
    AggregatesCarrier: 'Aggregates Carrier',
    AlcoholTanker: 'Alcohol Tanker',
    AsphaltBitumenTanker: 'Asphalt/Bitumen Tanker',
    BargeCarrier: 'Barge Carrier',
    BeerTanker: 'Beer Tanker',
    BitumenTanker: 'Bitumen Tanker',
    BulkCarrierLakerOnly: 'Bulk Carrier, Laker only',
    BulkCarrier: 'Bulk Carrier',
    BulkCarrierSelfDischargingLaker: 'Bulk Carrier, Self-Discharging, Laker',
    BulkCarrierSelfDischarging: 'Bulk Carrier, Self-Discharging',
    BulkCarrierWithVehicleDecks: 'Bulk Carrier (with Vehicle Decks)',
    BulkCarriers: 'Bulk Carriers',
    BulkCausticSodaCarrierCabu: 'Bulk/Caustic Soda Carrier (CABU)',
    BulkDryOil: 'Bulk Dry/Oil',
    BulkDry: 'Bulk Dry',
    BulkOilCarrier: 'Bulk/Oil Carrier',
    BulkOilCarrierObo: 'Bulk/Oil Carrier (OBO)',
    BulkOilChemicalCarrierCleanbu: 'Bulk/Oil/Chemical Carrier (CLEANBU)',
    BulkSulphuricAcidCarrier: 'Bulk/Sulphuric Acid Carrier',
    CaprolactamTanker: 'Caprolactam Tanker',
    CargoCarrying: 'Cargo Carrying',
    CementCarrier: 'Cement Carrier',
    Chemical: 'Chemical',
    ChemicalOilProductsTanker: 'Chemical/Oil Products Tanker',
    ChemicalProductsTanker: 'Chemical/Products Tanker',
    ChemicalTanker: 'Chemical Tanker',
    CngTanker: 'CNG Tanker',
    Co2Tanker: 'CO2 Tanker',
    CoalOilMixtureTanker: 'Coal/Oil Mixture Tanker',
    CombinationGasTankerLngLpg: 'Combination Gas Tanker (LNG/LPG)',
    Container: 'Container',
    ContainerRoRoCargoShip: 'Container/Ro-Ro Cargo Ship',
    ContainerShipFullyCellular: 'Container Ship (Fully Cellular)',
    ContainerShipFullyCellularRoRoFacility: 'Container Ship (Fully Cellular/Ro-Ro Facility)',
    ContainerShip: 'Container Ship',
    CrudeOilProductsTanker: 'Crude/Oil Products Tanker',
    CrudeOilTanker: 'Crude Oil Tanker',
    DeckCargoShip: 'Deck Cargo Ship',
    DryCargoPassenger: 'Dry Cargo/Passenger',
    EdibleOilTanker: 'Edible Oil Tanker',
    FruitJuiceCarrierRefrigerated: 'Fruit Juice Carrier, Refrigerated',
    FruitJuiceTanker: 'Fruit Juice Tanker',
    GeneralCargo: 'General Cargo',
    GeneralCargoPassengerShip: 'General Cargo/Passenger Ship',
    GeneralCargoShip: 'General Cargo Ship',
    GeneralCargoShipOpenHatch: 'General Cargo Ship (Open Hatch)',
    GeneralCargoShipWithRoRoFacility: 'General Cargo Ship (with Ro-Ro Facility)',
    GeneralCargoShipSelfDischarging: 'General Cargo Ship, Self-Discharging',
    GeneralCargoTankerContainerOilBulkCobShip: 'General Cargo/Tanker (Container/Oil/Bulk - COB Ship)',
    GeneralCargoTanker: 'General Cargo/Tanker',
    GlueTanker: 'Glue Tanker',
    HeavyLoadCarrier: 'Heavy Load Carrier',
    HeavyLoadCarrierSemiSubmersible: 'Heavy Load Carrier, Semi Submersible',
    LandingCraft: 'Landing Craft',
    LatexTanker: 'Latex Tanker',
    LimestoneCarrier: 'Limestone Carrier',
    LiquefiedGas: 'Liquefied Gas',
    LiquefiedHydrogenTanker: 'Liquefied Hydrogen Tanker',
    LivestockCarrier: 'Livestock Carrier',
    LngTanker: 'LNG Tanker',
    LpgChemicalTanker: 'LPG/Chemical Tanker',
    LpgTanker: 'LPG Tanker',
    MolassesTanker: 'Molasses Tanker',
    MoltenSulphurTanker: 'Molten Sulphur Tanker',
    NuclearFuelCarrier: 'Nuclear Fuel Carrier',
    NuclearFuelCarrierWithRoRoFacility: 'Nuclear Fuel Carrier (with Ro-Ro Facility)',
    Oil: 'Oil',
    OilProductsTanker: 'Oil Products Tanker',
    OreCarrier: 'Ore Carrier',
    OreOilCarrier: 'Ore/Oil Carrier',
    OtherBulkDry: 'Other Bulk Dry',
    OtherDryCargo: 'Other Dry Cargo',
    OtherLiquids: 'Other Liquids',
    PalletisedCargoShip: 'Palletised Cargo Ship',
    PassengerContainerShip: 'Passenger/Container Ship',
    PassengerCruiseShip: 'Passenger (Cruise) Ship',
    PassengerGeneralCargoShip: 'Passenger/General Cargo Ship',
    PassengerLandingCraft: 'Passenger/Landing Craft',
    Passenger: 'Passenger',
    PassengerRoRoCargoShip: 'Passenger/Ro-Ro Cargo Ship',
    PassengerRoRoShipVehicles: 'Passenger/Ro-Ro Ship (Vehicles)',
    PassengerRoRoShipVehiclesRail: 'Passenger/Ro-Ro Ship (Vehicles/Rail)',
    PassengerShip: 'Passenger Ship',
    PassengerGeneralCargo: 'Passenger/General Cargo',
    PowderCarrier: 'Powder Carrier',
    ProductsTanker: 'Products Tanker',
    PulpCarrier: 'Pulp Carrier',
    RailVehiclesCarrier: 'Rail Vehicles Carrier',
    RefinedSugarCarrier: 'Refined Sugar Carrier',
    RefrigeratedCargo: 'Refrigerated Cargo',
    RefrigeratedCargoShip: 'Refrigerated Cargo Ship',
    RoRoCargo: 'Ro-Ro Cargo',
    RoRoCargoShip: 'Ro-Ro Cargo Ship',
    SelfDischargingBulkCarrier: 'Self Discharging Bulk Carrier',
    SelfDischargingBulkDry: 'Self Discharging Bulk Dry',
    ShuttleTanker: 'Shuttle Tanker',
    TankerUnspecified: 'Tanker (Unspecified)',
    Tankers: 'Tankers',
    UreaCarrier: 'Urea Carrier',
    VegetableOilTanker: 'Vegetable Oil Tanker',
    VehiclesCarrier: 'Vehicles Carrier',
    WaterTanker: 'Water Tanker',
    WineTanker: 'Wine Tanker',
    WoodChipsCarrier: 'Wood Chips Carrier',
    YachtCarrierSemiSubmersible: 'Yacht Carrier, Semi Submersible',
    BulkCementCarrierInlandWaterways: 'Bulk Cement Carrier, Inland Waterways',
    ChemicalProductsTankerInlandWaterways: 'Chemical/Products Tanker, Inland Waterways',
    ChemicalTankerInlandWaterways: 'Chemical Tanker, Inland Waterways',
    ContainerShipFullyCellularInlandWaterways: 'Container Ship (Fully Cellular), Inland Waterways',
    CruiseShipInlandWaterways: 'Cruise Ship, Inland Waterways',
    DredgingInlandWaterways: 'Dredging, Inland Waterways',
    EdibleOilTankerInlandWaterways: 'Edible Oil Tanker, Inland Waterways',
    FishingInlandWaterways: 'Fishing, Inland Waterways',
    GeneralCargoInlandWaterways: 'General Cargo, Inland Waterways',
    GeneralCargoPassengerShipInlandWaterways: 'General Cargo/Passenger Ship, Inland Waterways',
    HullCleaningBargeInlandWaterways: 'Hull Cleaning Barge, Inland Waterways',
    InlandWaterwaysChemicalTanker: 'Inland Waterways Chemical Tanker',
    InlandWaterwaysDredging: 'Inland Waterways Dredging',
    InlandWaterwaysDryCargo: 'Inland Waterways Dry Cargo',
    InlandWaterwaysFishing: 'Inland Waterways Fishing',
    InlandWaterwaysLpgTanker: 'Inland Waterways LPG Tanker',
    InlandWaterwaysOilTanker: 'Inland Waterways Oil Tanker',
    InlandWaterwaysOtherActivities: 'Inland Waterways Other Activities',
    InlandWaterwaysOtherLiquidsTanker: 'Inland Waterways Other Liquids Tanker',
    InlandWaterwaysPassengerGeneralCargo: 'Inland Waterways Passenger/General Cargo',
    InlandWaterwaysPassenger: 'Inland Waterways Passenger',
    InlandWaterwaysPassengerRoRoCargo: 'Inland Waterways Passenger/Ro-Ro Cargo',
    InlandWaterwaysResearch: 'Inland Waterways Research',
    InlandWaterwaysRoRoCargo: 'Inland Waterways Ro-Ro Cargo',
    InlandWaterwaysTowingPushing: 'Inland Waterways Towing/Pushing',
    LpgTankerInlandWaterways: 'LPG Tanker, Inland Waterways',
    NonSeagoingMerchantShips: 'Non Seagoing Merchant Ships',
    OilTankerInlandWaterways: 'Oil Tanker, Inland Waterways',
    OtherActivitiesInlandWaterways: 'Other Activities, Inland Waterways',
    OtherNonSeagoing: 'Other Non Seagoing',
    PalletShuttlePontoonInlandWaterways: 'Pallet Shuttle Pontoon, Inland Waterways',
    PassengerRoRoShipVehiclesInlandWaterways: 'Passenger/Ro-Ro Ship (Vehicles), Inland Waterways',
    PassengerRoRoShipVehiclesTrainInland: 'Passenger/Ro-Ro Ship (Vehicles/Train), Inland',
    PassengerShipInlandWaterways: 'Passenger Ship, Inland Waterways',
    ResearchInlandWaterways: 'Research, Inland Waterways',
    RoRoCargoShipInlandWaterways: 'Ro-Ro Cargo Ship, Inland Waterways',
    TankerInlandWaterways: 'Tanker, Inland Waterways',
    TowingPushingInlandWaterways: 'Towing/Pushing, Inland Waterways',
    VegetableOilTankerInlandWaterways: 'Vegetable Oil Tanker, Inland Waterways',
    WaterTankerInlandWaterways: 'Water Tanker, Inland Waterways',
    AccommodationVesselStationary: 'Accommodation Vessel, Stationary',
    AircraftCarrier: 'Aircraft Carrier',
    AircraftTransportNavalAuxiliary: 'Aircraft Transport, Naval auxiliary',
    AttackVesselNaval: 'Attack Vessel, Naval',
    BoomDefenceVessel: 'Boom Defence Vessel',
    CommandVessel: 'Command Vessel',
    Corvette: 'Corvette',
    CraneVesselNavalAuxiliary: 'Crane Vessel, Naval Auxiliary',
    Cruiser: 'Cruiser',
    DegaussingVessel: 'Degaussing Vessel',
    Destroyer: 'Destroyer',
    DivingVesselNavalAuxiliary: 'Diving Vessel, Naval Auxiliary',
    Escort: 'Escort',
    Frigate: 'Frigate',
    HelicopterCarrier: 'Helicopter Carrier',
    InfantryLandingCraft: 'Infantry Landing Craft',
    LandingShipDockType: 'Landing Ship (Dock Type)',
    Lightship: 'Lightship',
    LogisticsVesselNavalRoRoCargo: 'Logistics Vessel (Naval Ro-Ro Cargo)',
    Minehunter: 'Minehunter',
    Minelayer: 'Minelayer',
    Minesweeper: 'Minesweeper',
    MunitionsCarrier: 'Munitions Carrier',
    MuseumStationary: 'Museum, Stationary',
    NavalNavalAuxiliary: 'Naval/Naval Auxiliary',
    NavalSmallCraft: 'Naval Small Craft',
    Netlayer: 'Netlayer',
    NonMerchantShips: 'Non Merchant Ships',
    OtherNonMerchantShips: 'Other Non Merchant Ships',
    RadioStationVessel: 'Radio Station Vessel',
    ReplenishmentDryCargoVessel: 'Replenishment Dry Cargo Vessel',
    ReplenishmentTanker: 'Replenishment Tanker',
    RestaurantVesselStationary: 'Restaurant Vessel, Stationary',
    SailTrainingShip: 'Sail Training Ship',
    SeaplaneTender: 'Seaplane Tender',
    SubmarineChaser: 'Submarine Chaser',
    Submarine: 'Submarine',
    SubmarineSalvageVessel: 'Submarine Salvage Vessel',
    TankLandingCraft: 'Tank Landing Craft',
    TorpedoBoat: 'Torpedo Boat',
    TorpedoRecoveryVessel: 'Torpedo Recovery Vessel',
    TorpedoTrialsVessel: 'Torpedo Trials Vessel',
    TrainingShipStationary: 'Training Ship, Stationary',
    Troopship: 'Troopship',
    TugNavalAuxiliary: 'Tug, Naval Auxiliary',
    UnknownFunctionNavalNavalAuxiliary: 'Unknown Function, Naval/Naval Auxiliary',
    WeaponsTrialsVessel: 'Weapons Trials Vessel',
    Yacht: 'Yacht',
    YachtSailing: 'Yacht (Sailing)',
    AccommodationShip: 'Accommodation Ship',
    AnchorHandlingTugSupply: 'Anchor Handling Tug Supply',
    AnchorHoy: 'Anchor Hoy',
    ArticulatedPusherTug: 'Articulated Pusher Tug',
    BackhoeDredger: 'Backhoe Dredger',
    BucketHopperDredger: 'Bucket Hopper Dredger',
    BucketLadderDredger: 'Bucket Ladder Dredger',
    BucketWheelSuctionDredger: 'Bucket Wheel Suction Dredger',
    BulkCementStorageShip: 'Bulk Cement Storage Ship',
    BulkDryStorageShip: 'Bulk Dry Storage Ship',
    BunkeringTankerLng: 'Bunkering Tanker (LNG)',
    BunkeringTankerLngOil: 'Bunkering Tanker (LNG/Oil)',
    BunkeringTanker: 'Bunkering Tanker',
    BunkeringTankerOil: 'Bunkering Tanker (Oil)',
    BuoyLighthouseTender: 'Buoy & Lighthouse Tender',
    BuoyLighthouseVessel: 'Buoy/Lighthouse Vessel',
    BuoyTender: 'Buoy Tender',
    CableLayer: 'Cable Layer',
    CableRepairShip: 'Cable Repair Ship',
    CommissioningServiceOperationVessel: 'Commissioning Service Operation Vessel',
    CraneShip: 'Crane Ship',
    CraneVessel: 'Crane Vessel',
    CrewBoat: 'Crew Boat',
    CrewSupplyVessel: 'Crew/Supply Vessel',
    CutterSuctionDredger: 'Cutter Suction Dredger',
    DivingSupportVessel: 'Diving Support Vessel',
    Dredger: 'Dredger',
    DredgerUnspecified: 'Dredger (Unspecified)',
    Dredging: 'Dredging',
    DrillingShip: 'Drilling Ship',
    DryStorage: 'Dry Storage',
    EffluentCarrier: 'Effluent carrier',
    ExhibitionVessel: 'Exhibition Vessel',
    FireFightingVessel: 'Fire Fighting Vessel',
    FishCarrier: 'Fish Carrier',
    FishCatching: 'Fish Catching',
    FishFactoryShip: 'Fish Factory Ship',
    FishFarmSupportVessel: 'Fish Farm Support Vessel',
    FisheryPatrolVessel: 'Fishery Patrol Vessel',
    FisheryResearchVessel: 'Fishery Research Vessel',
    FisherySupportVessel: 'Fishery Support Vessel',
    Fishing: 'Fishing',
    FishingSupportVessel: 'Fishing Support Vessel',
    FishingVessel: 'Fishing Vessel',
    FpsoFloatingProductionStorageOffloading: 'FPSO (Floating, Production, Storage, Offloading)',
    FpsoOil: 'FPSO, Oil',
    FsoGas: 'FSO, Gas',
    FsoFloatingStorageOffloading: 'FSO (Floating, Storage, Offloading)',
    FsoOil: 'FSO, Oil',
    GasProcessingVessel: 'Gas Processing Vessel',
    GrabDredger: 'Grab Dredger',
    GrabHopperDredger: 'Grab Hopper Dredger',
    HopperDredger: 'Hopper Dredger',
    HopperDredgerUnspecified: 'Hopper/Dredger (Unspecified)',
    HopperMotor: 'Hopper, Motor',
    HospitalVessel: 'Hospital Vessel',
    Icebreaker: 'Icebreaker',
    IcebreakerResearch: 'Icebreaker/Research',
    Incinerator: 'Incinerator',
    KelpDredger: 'Kelp Dredger',
    LeisureVessels: 'Leisure Vessels',
    LighthouseTender: 'Lighthouse Tender',
    LogTippingShip: 'Log Tipping Ship',
    MiningVessel: 'Mining Vessel',
    Miscellaneous: 'Miscellaneous',
    MissionShip: 'Mission Ship',
    MooringVessel: 'Mooring Vessel',
    MotorHopper: 'Motor Hopper',
    OffshoreConstructionVesselJackUp: 'Offshore Construction Vessel, Jack Up',
    Offshore: 'Offshore',
    OffshoreSupply: 'Offshore Supply',
    OffshoreSupportVessel: 'Offshore Support Vessel',
    OffshoreTugSupplyShip: 'Offshore Tug/Supply Ship',
    OtherActivities: 'Other Activities',
    OtherFishing: 'Other Fishing',
    OtherOffshore: 'Other Offshore',
    PatrolVessel: 'Patrol Vessel',
    PearlShellsCarrier: 'Pearl Shells Carrier',
    PileDrivingVessel: 'Pile Driving Vessel',
    PilotVessel: 'Pilot Vessel',
    PipeBuryingVessel: 'Pipe Burying Vessel',
    PipeCarrier: 'Pipe Carrier',
    PipeLayerCraneVessel: 'Pipe Layer Crane Vessel',
    PipeLayer: 'Pipe Layer',
    PlatformSupplyShip: 'Platform Supply Ship',
    PollutionControlVessel: 'Pollution Control Vessel',
    PowerStationVessel: 'Power Station Vessel',
    ProductionTestingVessel: 'Production Testing Vessel',
    PusherTug: 'Pusher Tug',
    Research: 'Research',
    ResearchSurveyVessel: 'Research Survey Vessel',
    ResearchVessel: 'Research Vessel',
    RocketLaunchSupportShip: 'Rocket Launch Support Ship',
    SailingVessel: 'Sailing Vessel',
    SalvageShip: 'Salvage Ship',
    SealCatcher: 'Seal Catcher',
    SearchRescueVessel: 'Search & Rescue Vessel',
    ServiceOperationVessel: 'Service Operation Vessel',
    StandbySafetyVessel: 'Standby Safety Vessel',
    StoneCarrier: 'Stone Carrier',
    SuctionDredger: 'Suction Dredger',
    SuctionHopperDredger: 'Suction Hopper Dredger',
    SupplyTender: 'Supply Tender',
    TankCleaningVessel: 'Tank Cleaning Vessel',
    TheatreVessel: 'Theatre Vessel',
    TowingPushing: 'Towing/Pushing',
    TrailingSuctionHopperDredger: 'Trailing Suction Hopper Dredger',
    TrainingShip: 'Training Ship',
    TransShipmentVessel: 'Trans Shipment Vessel',
    TrenchingSupportVessel: 'Trenching Support Vessel',
    Tug: 'Tug',
    UtilityVessel: 'Utility Vessel',
    VesselFunctionUnknown: 'Vessel (Function Unknown)',
    WasteDisposalVessel: 'Waste Disposal Vessel',
    WaterInjectionDredger: 'Water Injection Dredger',
    WellStimulationVessel: 'Well Stimulation Vessel',
    WhaleCatcher: 'Whale Catcher',
    WindTurbineVessel: 'Wind Turbine Vessel',
    WorkRepairVessel: 'Work/Repair Vessel',
    WorkVessel: 'Work Vessel',
    AccommodationPlatformJackUp: 'Accommodation Platform, Jack Up',
    AccommodationPlatformSemiSubmersible: 'Accommodation Platform, Semi Submersible',
    AirCushionVehicleHovercraft: 'Air Cushion Vehicle (Hovercraft)',
    AirCushionVehiclePassenger: 'Air Cushion Vehicle Passenger',
    AirCushionVehiclePassengerRoRoVehicles: 'Air Cushion Vehicle Passenger/Ro-Ro(Vehicles)',
    AirCushionVehiclePatrolVessel: 'Air Cushion Vehicle Patrol Vessel',
    AirCushionVehicleWorkVessel: 'Air Cushion Vehicle, Work Vessel',
    Buoy: 'Buoy',
    CranePlatformJackUp: 'Crane Platform, Jack Up',
    DivingSupportPlatformSemiSubmersible: 'Diving Support Platform, Semi Submersible',
    DockGate: 'Dock Gate',
    DrillingRigJackUp: 'Drilling Rig, Jack Up',
    DrillingRigSemiSubmersible: 'Drilling Rig, Semi Submersible',
    FloatingDock: 'Floating Dock',
    LinkspanJetty: 'Linkspan/Jetty',
    MaintenancePlatformSemiSubmersible: 'Maintenance Platform, Semi Submersible',
    MechanicalLiftDock: 'Mechanical Lift Dock',
    MooringBuoy: 'Mooring Buoy',
    NonShipStructures: 'Non Ship Structures',
    PipeLayerPlatformSemiSubmersible: 'Pipe Layer Platform, Semi Submersible',
    Platform: 'Platform',
    ProductionPlatformJackUp: 'Production Platform, Jack Up',
    ProductionPlatformSemiSubmersible: 'Production Platform, Semi Submersible',
    PumpingPlatform: 'Pumping Platform',
    Submersible: 'Submersible',
    SupplyPlatformJackUp: 'Supply Platform, Jack Up',
    SupportPlatformJackUp: 'Support Platform, Jack Up',
    UnderwaterSystem: 'Underwater System',
    WindTurbineInstallationPlatformJackUp: 'Wind Turbine Installation Platform, Jack Up',
    WingInGroundEffectVessel: 'Wing In Ground Effect Vessel',
    AccommodationPontoonNonPropelled: 'Accommodation Pontoon, Non Propelled',
    Barge: 'Barge',
    BitumenTankBargeNonPropelled: 'Bitumen Tank Barge, Non Propelled',
    BucketDredgerPontoon: 'Bucket Dredger Pontoon',
    BulkAggregatesBargeNonPropelled: 'Bulk Aggregates Barge, Non Propelled',
    BulkCementBargeNonPropelled: 'Bulk Cement Barge, Non Propelled',
    CarPark: 'Car Park',
    CementStorageBargeNonPropelled: 'Cement Storage Barge, Non Propelled',
    ChemicalProductsTankBargeNonPropelled: 'Chemical/Products Tank Barge, Non Propelled',
    ChemicalTankBargeNonPropelled: 'Chemical Tank Barge, Non Propelled',
    CoveredBulkCargoBargeNonPropelled: 'Covered Bulk Cargo Barge, Non Propelled',
    CraneVesselNonPropelled: 'Crane Vessel, Non Propelled',
    CrudeOilTankBargeNonPropelled: 'Crude Oil Tank Barge, Non Propelled',
    DeckCargoPontoonNonPropelled: 'Deck Cargo Pontoon, Non Propelled',
    DeckCargoPontoonSemiSubmersible: 'Deck Cargo Pontoon, Semi Submersible',
    DesalinationPontoonNonPropelled: 'Desalination Pontoon, Non Propelled',
    DredgingPontoonUnknownDredgingType: 'Dredging Pontoon, Unknown Dredging Type',
    DrillingBargeNonPropelled: 'Drilling Barge, Non Propelled',
    FishStorageBargeNonPropelled: 'Fish Storage Barge, Non Propelled',
    GeneralCargoBargeNonPropelled: 'General Cargo Barge, Non Propelled',
    GrabDredgerPontoon: 'Grab Dredger Pontoon',
    GrainElevatingPontoonNonPropelled: 'Grain Elevating Pontoon, Non Propelled',
    HopperBargeNonPropelled: 'Hopper Barge, Non Propelled',
    JacketLaunchingPontoonSemiSubmersible: 'Jacket Launching Pontoon, Semi Submersible',
    LngTankBargeNonPropelled: 'LNG Tank Barge, Non Propelled',
    LpgTankBargeNonPropelled: 'LPG Tank Barge, Non Propelled',
    NonPropelledBarge: 'Non Propelled Barge',
    NonPropelled: 'Non Propelled',
    PontoonFunctionUnknown: 'Pontoon (Function Unknown)',
    Pontoon: 'Pontoon',
    PowerStationPontoonNonPropelled: 'Power Station Pontoon, Non Propelled',
    ProductsTankBargeNonPropelled: 'Products Tank Barge, Non Propelled',
    SheerlegsPontoon: 'Sheerlegs Pontoon',
    ShoppingComplex: 'Shopping Complex',
    SteamSupplyPontoonNonPropelled: 'Steam Supply Pontoon, Non Propelled',
    SuctionDredgerPontoon: 'Suction Dredger Pontoon',
    TransShipmentBargeNonPropelled: 'Trans Shipment Barge, Non Propelled',
    WaterInjectionDredgingPontoon: 'Water-injection Dredging Pontoon',
    WaterTankBargeNonPropelled: 'Water Tank Barge, Non Propelled',
    WorkMaintenancePontoonNonPropelled: 'Work/Maintenance Pontoon, Non Propelled'
} as const;
export type QueryQueryGetVesselTypeMatchEnum = typeof QueryQueryGetVesselTypeMatchEnum[keyof typeof QueryQueryGetVesselTypeMatchEnum];
/**
 * @export
 */
export const QueryQueryGetVesselStatusMatchEnum = {
    UnderConstruction: 'UNDER_CONSTRUCTION',
    InService: 'IN_SERVICE',
    Converting: 'CONVERTING',
    Casualty: 'CASUALTY',
    Demolition: 'DEMOLITION',
    LaidUp: 'LAID_UP'
} as const;
export type QueryQueryGetVesselStatusMatchEnum = typeof QueryQueryGetVesselStatusMatchEnum[keyof typeof QueryQueryGetVesselStatusMatchEnum];
/**
 * @export
 */
export const QueryQueryGetEngineTypeMatchEnum = {
    Diesel: 'DIESEL',
    Electric: 'ELECTRIC',
    SteamTurbine: 'STEAM_TURBINE',
    DieselAndGasTurbine: 'DIESEL_AND_GAS_TURBINE',
    GasTurbine: 'GAS_TURBINE',
    NonPropelled: 'NON_PROPELLED',
    Hybrid: 'HYBRID',
    Gasoline: 'GASOLINE',
    DieselAndGasoline: 'DIESEL_AND_GASOLINE',
    NoEngine: 'NO_ENGINE',
    Reciprocating: 'RECIPROCATING'
} as const;
export type QueryQueryGetEngineTypeMatchEnum = typeof QueryQueryGetEngineTypeMatchEnum[keyof typeof QueryQueryGetEngineTypeMatchEnum];
/**
 * @export
 */
export const QueryQueryGetSanctionTypeMatchEnum = {
    FinancialMeasures: 'FINANCIAL_MEASURES',
    Blocked: 'BLOCKED',
    ArmsExport: 'ARMS_EXPORT',
    ArmsImport: 'ARMS_IMPORT',
    DualUseGoodsExport: 'DUAL-USE_GOODS_EXPORT',
    DualUseGoodsImport: 'DUAL-USE_GOODS_IMPORT',
    RestrictionsOnGoods: 'RESTRICTIONS_ON_GOODS',
    PortsAndVessels: 'PORTS_AND_VESSELS'
} as const;
export type QueryQueryGetSanctionTypeMatchEnum = typeof QueryQueryGetSanctionTypeMatchEnum[keyof typeof QueryQueryGetSanctionTypeMatchEnum];
